import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle } from 'recompose'
import { injectIntl } from 'react-intl'

import { getFullActionInfo } from '../selectors/actions.js'
import { getAction } from '../store/reducers/actions/list.js'
import { clear } from '../store/reducers/actions/action.js'

import { FormattedMessage } from 'react-intl'

import MainContainer from './Main'

const ActionPage = ({ info, lots = [], persons = [], intl }) => {
  console.log('info', info)
  if (info) return (
    <div className='Container Container_top-negative'>
      <div class="Sidebar Sidebar_privacy">
        <div class="Sidebar__body Sidebar__body_privacy">
          <h1 class="Sidebar__head Sidebar__head_privacy">ПУБЛИЧНАЯ ОФЕРТА</h1>
        </div>
      </div>
      <pre className='Main Main_privacy' dangerouslySetInnerHTML={{ __html: info.offer }} />
    </div>
  ); else return null
}

const mapStateToProps = () => {
  const getInfo = getFullActionInfo()
  return (state, props) => {
    return ({
      info: getInfo(state, props),
      ...state.actions.action
    })
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  getAction,
  clear
}, dispatch)

const mergeProps = (state, dispatch, props) => {
  const getDetails = async (id) => {
    if (!id) return
    await Promise.all([
    ])
  }
  const getInfo = async (id) => {
    id = id || props.id
    if (!id) return
    let code
    if (!props.info) code = await dispatch.getAction(id)
    if (props.info || code === 200) await getDetails(id)
    if (!props.info && code !== 200) props.on404()
  }
  return { ...props, ...state, getInfo }
}

export default injectIntl(compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  lifecycle({
    async componentWillMount() {
      await this.props.getInfo()
    },
    componentWillReceiveProps(np) {
      if (np.id !== this.props.id) this.props.getInfo(np.id)
    }
  })
)(ActionPage))



// WEBPACK FOOTER //
// ./src/containers/Offer.jsx